export default "__VITE_ASSET__C6e_67zY__"